import type { TournamentFragment } from '~/client/features/Tournaments/graphql/TournamentFragment.generated';
import Header from './Header';
import LeaderboardItem from './LeaderboardItem';
import useLeaderboardList from './useLeaderboardList';

type Props = {
  tournament?: TournamentFragment;
};

const LeaderboardList: FC<Props> = ({ tournament }) => {
  const { initialList, listWithUser } = useLeaderboardList(tournament);
  return (
    <div className="grid gap-4 bg-gohan">
      <Header />
      <div className="grid gap-1">
        <div className="[&_>_div:last-child]:border-b [&_>_div:last-child]:border-dashed [&_>_div:last-child]:border-bulma">
          {initialList?.map((item) => (
            <LeaderboardItem
              key={item?.id}
              isMyScore={item?.isMyScore}
              points={item?.points}
              username={item?.username}
              position={item?.position}
            />
          ))}
        </div>
        {tournament?.iAmOptedIn && listWithUser?.length ? (
          <>
            {listWithUser?.map((item) => (
              <LeaderboardItem
                key={item?.position}
                isMyScore={item?.isMyScore}
                points={item?.points}
                username={item?.username}
                position={item?.position}
              />
            ))}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default LeaderboardList;
